// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from '@hotwired/stimulus';
import {
  AutosizeController,
  AutoSubmitFormController,
  ConfirmController,
  DismissableController,
  FormDirtyConfirmNavigationController,
  PersistedDismissableController,
  RefreshPageController,
  ScrollIntoFocusController,
  SelfDestructController,
  SignalDisableController,
  SignalInputController,
  SignalVisibilityController,
  SyncInputsController,
  TableSortController,
  TableTruncateController,
  ToggleClassController,
  TrixModifierController,
} from 'stimulus-library/dist';

const application = Application.start();
application.debug = true;

// Register each controller with Stimulus
const controllerContext = import.meta.glob(
  [
    './**/*_controller.js',
    '../../components/**/*_controller.js',
  ],
  { eager: true },
);

Object.entries(controllerContext).forEach(([path, module]) => {
  const match = path.match(/([^/]+)_controller\.js$/);
  if (!match || !module?.default) {
    return;
  }

  path = path.replace(/^\.\//, ''); // Remove leading './' from path
  path = path.replaceAll('../../components/', ''); // Remove components directory prefix
  path = path.replaceAll('/', '--'); // Replace slashes with dashes for Stimulus identifier
  path = path.replaceAll('_controller', ''); // Remove file extension
  path = path.replaceAll('.js', ''); // Remove file extension

  const identifier = path.replace(/_/g, '-'); // "rich-text-input"
  application.register(identifier, module.default);
});

application.register('auto-submit-form', AutoSubmitFormController);
application.register('autosize', AutosizeController);
application.register('confirm', ConfirmController);
application.register('dismissable', DismissableController);
application.register('form-dirty-confirm-navigation', FormDirtyConfirmNavigationController);
application.register('persisted-dismissable', PersistedDismissableController);
application.register('refresh-page', RefreshPageController);
application.register('self-destruct', SelfDestructController);
application.register('scroll-into-focus', ScrollIntoFocusController);
application.register('signal-disable', SignalDisableController);
application.register('signal-input', SignalInputController);
application.register('signal-visibility', SignalVisibilityController);
application.register('sync-inputs', SyncInputsController);
application.register('table-sort', TableSortController);
application.register('table-truncate', TableTruncateController);
application.register('toggle-class', ToggleClassController);
application.register('trix-modifier', TrixModifierController);
